import React, { useMemo } from 'react'
import MyBarChart from '../MyBarChart'
import MySpiderChart, { CallbackEventClickChart, ISpiderChart } from '../MySpiderChart'
import { OptionsOverviewDashboard } from './OverviewDashboardType'

type DimensionDashboardProps = {
    options: OptionsOverviewDashboard
    color?: string[]
    radarProps?: ISpiderChart
    onClickChart?: (values: CallbackEventClickChart) => void
    displayPoint?: boolean
}

type TUseDimensionDashboard = {} & DimensionDashboardProps
type TReturnTypeHooks = ReturnType<typeof useChartRadarDashboard>
const useChartRadarDashboard = ({ options, color, displayPoint = true, ...props }: TUseDimensionDashboard) => {
    const { dimensions = [] } = options
    const dataset = useMemo(() => {
        return [
            // ชั้นแรกเอาไว้แสดงจุดที่มุม chart
            {
                label: '',
                pointHitRadius: 55,
                // hitRadius: 10, // ระยะห่างในการ hover
                data: Array(dimensions.length).fill(options.fullScore),
                pointHoverBorderWidth: 4, // ห่าง 2
                pointBorderWidth: 6,
                fill: false,
                pointHoverBackgroundColor: color,
                pointBackgroundColor: color,
                borderWidth: 2,
                borderColor: '#b7b7b7',
                pointBorderColor: color,
                pointHoverBorderColor: color,
                pointRadius: displayPoint ? 3 : 0,
                pointHoverRadius: displayPoint ? 4 : 0,
            },
            // ชั้นแรกเอาไว้แสดงจุดที่มุม chart
            {
                label: 'คะแนนการประเมินโดยเจ้าหน้าที่',
                fill: false,
                data: dimensions.map((item) => item.scoreAdmin),
                hitRadius: 3, // ระยะห่างในการ hover
                pointRadius: 0,
                pointBackgroundColor: color,
                borderColor: '#009687',
                pointBorderColor: color,
                borderWidth: 4,
                pointHoverRadius: displayPoint ? 4 : 0,
                backgroundColor: dimensions.map(() => '#009687'),
                barPercentage: 0.2,
                barThickness: 50,
                // pointHitRadius: 4,
            },
            {
                label: 'คะแนนการประเมินโดยตนเอง',
                fill: false,
                data: dimensions.map((item) => item.scoreUser),
                hitRadius: 3, // ระยะห่างในการ hover
                pointRadius: 0,
                pointBackgroundColor: color,
                borderColor: '#F5D01A',
                pointBorderColor: color,
                borderWidth: 4,
                pointHoverRadius: displayPoint ? 4 : 0,
                backgroundColor: dimensions.map(() => '#F5D01A'),
                barPercentage: 0.2,
                barThickness: 50,
                // pointHitRadius: 4,
            },
        ]
    }, [options, color, dimensions, displayPoint])

    const labelsCustom = useMemo(() => {
        return {
            labels: dimensions.map((item, index) => `${options.prefixLabel || 'ด้าน'}${index + 1}`),
            labelsCustomTooltips: dimensions.map(
                (item, index) => `${options.prefixLabel || 'ด้าน'}${index + 1} ${item.dimensionName}`,
            ),
        }
    }, [options, dimensions])

    return { dataset, labelsCustom }
}

const RadarChartDashboard: React.FC<DimensionDashboardProps> = ({
    options,
    color = [
        '#80BD01',
        '#FB7735',
        '#15C9DE',
        '#F30606',
        '#5E29BC',
        '#d312ec',
        '#54717d',
        '#e122a7',
        '#c69338',
        '#609622',
    ],
    onClickChart,
    radarProps,
    ...props
}) => {
    const { dataset, labelsCustom } = useChartRadarDashboard({ options, color, ...props })
    return labelsCustom.labels.length > 2 ? (
        <MySpiderChart
            datasets={dataset}
            labels={labelsCustom.labels}
            labelsCustomTooltips={labelsCustom.labelsCustomTooltips}
            positionLegend='bottom'
            onClickChart={onClickChart}
            {...radarProps}
        />
    ) : (
        <MyBarChart
            datasets={dataset}
            labels={labelsCustom.labels}
            labelsCustomTooltips={labelsCustom.labelsCustomTooltips}
            positionLegend='bottom'
            onClickChart={onClickChart}
            displayPoint={props.displayPoint}
            {...radarProps}
        />
    )
}

export default RadarChartDashboard
